import fetchJsonFromRpgLogsApi from './fetchJsonFromRpgLogsApi';
import { GameViewModel } from '../../resources/js/typings/viewModels/gameViewModel';
import GoogleAnalyticsViewModel from '../../resources/js/typings/viewModels/googleAnalyticsViewModel';
import ArticleCategoryViewModel from '../../resources/js/typings/viewModels/articleCategoryViewModel';
import PageOfArticlePreviewsViewModel from '../../resources/js/typings/viewModels/pageOfArticlePreviewsViewModel';
import CmsNavigationViewModel from '../../resources/js/typings/viewModels/cmsNavigationViewModel';
import getCommonViewModels from './getCommonViewModels';
import { ArchonHeaderViewModel } from '../components/ArchonHeader/ArchonHeader';
import { ArchonFooterViewModel } from '../components/ArchonFooter/ArchonFooter';

async function getArticleCategoryPageViewModels(
  articleCategorySlug: string,
  pageNumber: number,
  gameSlug: string
): Promise<{
  googleAnalytics: GoogleAnalyticsViewModel;
  game: GameViewModel;
  header: ArchonHeaderViewModel;
  footer: ArchonFooterViewModel;
  articleCategory: ArticleCategoryViewModel;
  cmsNavigation: CmsNavigationViewModel;
  pageOfArticlePreviews: PageOfArticlePreviewsViewModel;
}> {
  const data = await fetchJsonFromRpgLogsApi(
    `query($articleCategorySlug: String!, $pageNumber: Int!) {
      viewModels {
        game
        articleCategory(
          articleCategorySlug: $articleCategorySlug,
        )
        cmsNavigation(
          currentSlug: $articleCategorySlug,
        )
        pageOfArticlePreviews(
          articleCategorySlug: $articleCategorySlug,
          pageNumber: $pageNumber
        )
      }
    }`,
    {
      articleCategorySlug,
      pageNumber,
    },
    gameSlug
  );

  return {
    ...(await getCommonViewModels(gameSlug)),
    ...data.viewModels,
  };
}

export default getArticleCategoryPageViewModels;
